import DayGroupings from '../options/day-groupings'
import DayOptions from '../options/day-options'

export default class {
    constructor(day, range) {
        this.day = day;
        this.range = range;
    }

    getStartTime() {
        return this.range.startTime;
    }

    getEndTime() {
        return this.range.endTime;
    }

    dayDatabaseId() {
        return this.day ? this.day.databaseId : null;
    }

    rangeMinutesFromStartOfWeek() {
        const minutesFromStartOfWeekToStartOfDay = ((this.day.dayOfWeek) * 60 * 24);
        const rangeMinutesFromStartOfDay = this.range.minutesFromStartOfDay();

        return {
            startTime: minutesFromStartOfWeekToStartOfDay + rangeMinutesFromStartOfDay.startTime,
            endTime: minutesFromStartOfWeekToStartOfDay + rangeMinutesFromStartOfDay.endTime,
        };
    }

    isExpandable() {
        return this.day && _.has(DayGroupings, this.day.value);
    }

    expand() {
        return DayGroupings[this.day.value].map((day) => {
            return new this.constructor(
                _.find(DayOptions, { value: day }),
                this.range,
            );
        });
    }

    isValid() {
        return this.day && this.range.isValid();
    }
}
